import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouter } from "next/router";
import cx from "classnames";
import { Primary, Secondary } from "@cinch-labs/design-system";
import styles from "./auth-buttons.module.css";
export var AuthButtons = function(param) {
    var useBrowserNavigation = param.useBrowserNavigation;
    var router = useRouter();
    var handleLoginClicked = function() {
        useBrowserNavigation ? location.assign("/login") : router.push("/login");
    };
    var handleRegisterClicked = function() {
        useBrowserNavigation ? location.assign("/sign-up") : router.push("/sign-up");
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.actions,
        children: [
            /*#__PURE__*/ _jsx(Secondary, {
                classNames: {
                    button: cx(styles.button, styles.loginButton)
                },
                type: "button",
                onClick: function() {
                    handleLoginClicked();
                },
                variant: "default",
                children: "Log in"
            }),
            /*#__PURE__*/ _jsx(Primary, {
                classNames: {
                    button: styles.button
                },
                type: "button",
                onClick: function() {
                    handleRegisterClicked();
                },
                variant: "default",
                children: "Register"
            })
        ]
    });
};
